import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Item} from "../../models/Item";
import {ObjectConfig} from "../../models/ObjectConfig";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {FixedSizeComponent} from "../../components/fixed-size/fixed-size.component";

@Component({
  selector: 'app-fixed-size',
  templateUrl: './fixed-size.component.html',
  styleUrls: ['./fixed-size.component.scss']
})
export class FixedSizeComponent21 extends FixedSizeComponent implements OnDestroy{
  ngOnDestroy(): void {
    this.cd.detach();
    this.subscribers.unsubscribe();
  }
}
